export const KPI_METRIC_START_YEAR = 2024
